export const socketMessages = (sendSocketMessage: any) => {
  const placeBet = (
    stake: string,
    cashoutAt: string,
    isAutoOn?: boolean,
    setbetSend?: any,
  ) => {
    setbetSend(true)
    sendSocketMessage("bet", stake, "0", isAutoOn ? cashoutAt : "0")
  }
  const cashout = () => sendSocketMessage("cashout", "0")

  const settingsPost = (settings: any) =>
    sendSocketMessage("settings", settings)

  return {
    placeBet,
    cashout,
    settingsPost,
  }
}
